import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const AuthLoading: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}
    >
      <Box
        component="img"
        src="/images/logo.png"
        alt="KBR Life Care Logo"
        sx={{ 
          width: 80,
          height: 80,
          mb: 2,
          objectFit: 'contain'
        }} 
      />
      <CircularProgress 
        size={60} 
        sx={{ 
          color: 'white',
          mb: 3
        }} 
      />
      <Typography variant="h6" gutterBottom>
        KBR Life Care
      </Typography>
      <Typography variant="body2">
        Loading Admin Dashboard...
      </Typography>
    </Box>
  );
};

export default AuthLoading;